import script from "./CompletionHighlight.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletionHighlight.vue?vue&type=script&setup=true&lang=ts"

import "./CompletionHighlight.vue?vue&type=style&index=0&id=f1ae7246&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1ae7246"]])

export default __exports__